/**
 * @file 全局常量
 * @description 定义并规范特定量的名称
 */

import { isIOS } from '@utils/device';
import { bbtNative } from '@bbtfe/webview-bridge';
import { isInMiniProgram } from '@utils/development';

const USER_ID = 'enc_user_id'; // 用户id
const TOKEN = 'token'; // 用户token
const APP_ID = '11';

const getPlatform = () => {
  if (bbtNative.isApp()) {
    if (isIOS()) {
      return 2;
    } else {
      return 3;
    }
  } else if (isInMiniProgram()) {
    return 10;
  } else {
    return 1;
  }
};

export { USER_ID, TOKEN, APP_ID, getPlatform };
